<template>
  <div class="card-header mt-4 mt-md-2" v-if="schedules && schedules.length > 0">
    <div class="card-header border-0 pl-2 pt-2">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">Schedule Info</h3>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table :data="schedules">
        <template slot="columns">
          <th>League</th>
          <th>Home</th>
          <th>Away</th>
          <th>Date</th>
          <th>Time</th>
          <th>Edit</th>
          <th>Delete</th>
        </template>

        <template slot-scope="{row}">
          <td>{{row.league}}</td>
          <td>{{row.home.clubName}}</td>
          <td>{{row.away.clubName}}</td>
          <td>{{getLiveDate(row)}}</td>
          <td>{{getLiveTime(row)}}</td>
          <td class="pl-1">
            <button class="btn btn-info" @click="onEditClicked(row.id)">
              <img src="@/assets/icons/ic_edit.svg" /> Edit
            </button>
          </td>
          <td class="pl-1">
            <button class="btn btn-delete" @click="onDeleteClicked(row)">
              <img src="@/assets/icons/ic_delete.svg" />
              Delete
            </button>
          </td>
        </template>
      </base-table>
      <div class="card-footer d-flex justify-content-center">
        <base-pagination :page-count="totalPage" v-model="pagination" @input="onPageChanged"></base-pagination>
      </div>
    </div>
    <modal :show.sync="showModal">
      <h6 slot="header" class="modal-title" id="modal-title-notification">Your attention is required</h6>

      <div class="text-center">
        <img src="@/assets/icons/ic_danger.svg" />
        <h3 class="mt-4">Are you sure want to delete this schedule?</h3>
      </div>

      <template slot="footer">
        <div class="col-md-12 text-center">
          <base-button outline type="primary" class="btn-cancel" @click="showModal = false">Cancel</base-button>
          <button class="btn btn-pirmary btn-delete default-button" @click="onConfirmDelete()">
            <img src="@/assets/icons/ic_delete.svg" width="13" height="13" class="mb-1" /> Delete
          </button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { GET_LIVE_SCHEDULES, DELETE_SCHEDULE } from '@/store/actions.type'
import { mapState } from 'vuex'

import { appendZeroForDate } from '@/common/utils'

export default {
  name: 'schedule-info-table',
  data() {
    return {
      schedule: null,
      pagination: 1,
      showModal: false
    }
  },
  created() {
    this.$store.dispatch(GET_LIVE_SCHEDULES, this.pagination)
  },
  methods: {
    onPageChanged(page) {
      this.$store.dispatch(GET_LIVE_SCHEDULES, page)
    },
    getLiveDate(schedule) {
      const date = new Date(schedule.startedAt)
      return `${date.getFullYear()}-${appendZeroForDate(
        date.getMonth() + 1
      )}-${appendZeroForDate(date.getDate())}`
    },
    getLiveTime(schedule) {
      const date = new Date(schedule.startedAt)
      const minute = date.getMinutes() === 0 ? '00' : date.getMinutes()
      return `${appendZeroForDate(date.getHours())}:${minute}`
    },
    onEditClicked(id) {
      this.$router.push({ path: `schedule/${id}` })
    },
    onDeleteClicked(schedule) {
      this.showModal = true
      this.schedule = schedule
    },
    onConfirmDelete() {
      this.$store
        .dispatch(DELETE_SCHEDULE, this.schedule)
        .then(() => (this.showModal = false))
    }
  },
  computed: {
    ...mapState({
      schedules: state => state.schedule.schedules,
      totalPage: state => state.schedule.totalPage,
      isLoading: state => state.schedule.isLoading,
      error: state => state.schedule.error
    })
  }
}
</script>
<style scoped>
.btn-info {
  padding: 0.45rem 0.8rem !important;
  font-size: 0.65rem !important;
  border: none;
  color: white;
  padding: 12px 16px;
  font-size: 16px;
  cursor: pointer;
}
.btn-delete {
  padding: 0.45rem 0.8rem !important;
  font-size: 0.65rem !important;
  border: none;
  color: white;
  padding: 12px 16px;
  font-size: 16px;
  cursor: pointer;
  background-color: #f65858;
}
.btn-delete:hover {
  background-color: #f65858;
}
.btn-success {
  padding: 0.45rem 1.2rem !important;
  font-size: 0.65rem !important;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
}
.default-button {
  padding: 0.625rem 1.25rem !important;
  font-size: 0.875em !important;
}
.btn-cancel {
  border-color: #f65858 !important;
  color: #f65858 !important;
}
.btn-cancel:hover {
  background-color: transparent !important;
}
</style>
